const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

/** Orders */
const Orders = () => import('~/pages/orders/index').then(m => m.default || m)
const OrdersList = () => import('~/pages/orders/list').then(m => m.default || m)
const OrderCreate = () => import('~/pages/orders/create').then(m => m.default || m)
const OrderShow = () => import('~/pages/orders/show').then(m => m.default || m)
const OrderPrint = () => import('~/pages/orders/print').then(m => m.default || m)
const OrderPrintInvoice = () => import('~/pages/orders/printInvoice').then(m => m.default || m)
const OrderConsolidated = () => import('~/pages/orders/consolidated').then(m => m.default || m)

/** Vendors */
const Vendors = () => import('~/pages/vendors/index').then(m => m.default || m)
const VendorsList = () => import('~/pages/vendors/list').then(m => m.default || m)
const VendorCreate = () => import('~/pages/vendors/create').then(m => m.default || m)
const VendorShow = () => import('~/pages/vendors/show').then(m => m.default || m)

/** Products */
const Products = () => import('~/pages/products/index').then(m => m.default || m)
const ProductsList = () => import('~/pages/products/list').then(m => m.default || m)
const ProductCreate = () => import('~/pages/products/create').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  {
    path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ]
  },
  {
    path: '/orders',
    component: Orders,
    children: [
      { path: '', redirect: { name: 'orders.list' } },
      { path: 'list', name: 'orders.list', component: OrdersList },
      { path: 'create', name: 'orders.create', component: OrderCreate },
      { path: ':id/edit', name: 'orders.edit', component: OrderCreate, props: true },
      { path: ':id/show', name: 'orders.show', component: OrderShow, props: true },
      { path: 'consolidated-invoice', name: 'orders.consolidated', component: OrderConsolidated },
    ]
  },
  { path: '/orders/:id/print', name: 'orders.print', component: OrderPrint, props: true },
  { path: '/orders/:id/print-invoice', name: 'orders.printInvoice', component: OrderPrintInvoice, props: true },

  {
    path: '/vendors',
    component: Vendors,
    children: [
      { path: '', redirect: { name: 'vendors.list' } },
      { path: 'list', name: 'vendors.list', component: VendorsList },
      { path: 'create', name: 'vendors.create', component: VendorCreate },
      { path: ':id/edit', name: 'vendors.edit', component: VendorCreate, props: true },
      { path: ':id/show', name: 'vendors.show', component: VendorShow, props: true }
    ]
  },

  {
    path: '/products',
    component: Products,
    children: [
      { path: '', redirect: { name: 'products.list' } },
      { path: 'list', name: 'products.list', component: ProductsList },
      { path: 'create', name: 'products.create', component: ProductCreate },
      { path: ':id/edit', name: 'products.edit', component: ProductCreate, props: true }
    ]
  },

  { path: '*', component: NotFound }
]
